import React from 'react';
import { Popconfirm, Dropdown, Menu, notification } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faPrint } from '@fortawesome/free-solid-svg-icons';

import H3Text from '@Uilib/h3Text';
import SelectCustomStatus from '@Components/Common/SelectCustomStatus';
import Helpers from '@Apis/helpers';
import Crown from '@Images/crown2.png';
import { v4 as uuidv4 } from 'uuid';
import Constants from '@Apis/constants';

const addAlpha = (color, opacity) => {
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
};
const ViewConsumptionHeader = ({
  selectedInvoice,
  user,
  isQuickView,
  deleteInvoice,
  deleteInvoiceLoading,
  updateInvoiceStatus,
  getInvoiceById,
  match,
  history,
  setShowReturnSlipForm,
  setShowDCDrawer,
  downloadDocument,
}) => {

  const handleDelete = () => {
    const preventDelete = false;

    if (preventDelete) {
      notification.error({
        message: 'Sorry, you are not allowed to delete a packing slip for which Invoice has been created.',
        placement: 'top',
        duration: 4,
      });
    } else {
      deleteInvoice(
        {
          tenant_id: selectedInvoice?.tenant_id,
          invoice_id: match?.params?.consumptionId,
        },
        () => {
          history.push('/sales/consumption');
        }
      );
    }
  };

  const renderDropdownMenu = (
    <div style={{ width: '205px' }}>
      <Menu>
        {Helpers.getPermission(Helpers.permissionEntities.CONSUMPTION_ORDER, Helpers.permissionTypes.CREATE, user) &&
          user?.tenant_info?.sales_config?.sub_modules?.return_slip?.is_active && (
            <Menu.Item key="return-slip">
              <H3Text
                text={(
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div>+ Return Slip</div>
                  </div>
                )}
                className="hide__in-mobile"
                onClick={() => setShowReturnSlipForm(true)}
              />
            </Menu.Item>
          )}

        {Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.CREATE, user) &&
          !selectedInvoice?.shopify_order_id &&
          selectedInvoice?.delivery_challan_id === null && (
            <Menu.Item key="dc">
              <H3Text
                text={(
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div>+ Delivery Challan</div>
                    {!user?.tenant_info?.inventory_config?.sub_modules?.delivery_challan?.is_active && (
                      <Popconfirm
                        placement="topRight"
                        title="This feature is not accessible within your current plan. To use this feature contact us."
                        onConfirm={() => globalThis.Intercom('showNewMessage')}
                        okText="Contact Us"
                        cancelText="Cancel"
                      >
                        <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                      </Popconfirm>
                    )}
                  </div>
                )}
                className="hide__in-mobile"
                onClick={() => setShowDCDrawer(true)}
              />
            </Menu.Item>
          )}
      </Menu>
    </div>
  );

  return (
    <div className="view-document__title">
      <div className="view-document__title-number-wrapper">
        <H3Text
          text={selectedInvoice?.invoice_number}
          className="view-document__title-number"
        />
      </div>

      {!isQuickView && (
        <div className="view-document__title-actions">
          <div className="action-buttons">
            <div className="action-button " onClick={() => {
              downloadDocument({
                url: `${Constants.Invoice}/download?invoice_id=${selectedInvoice?.invoice_id}&tenant_id=${selectedInvoice?.tenant_id}&include_eWay_bill=false&download_document_in_base_currency=false`,
                document_type: 'CONSUMPTION_ORDER',
                document_number: selectedInvoice?.invoice_number,
                key: uuidv4(),
              });
            }}>
              <FontAwesomeIcon icon={faPrint} style={{ fontSize: '16px', width: '35px', textAlign: 'center' }} />
            </div>
            {Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.DELETE, user) && (
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to delete this Consumption Order?"
                onConfirm={handleDelete}
                okText="Yes"
                cancelText="No"
              >
                <H3Text
                  text={
                    deleteInvoiceLoading ? (
                      <LoadingOutlined />
                    ) : (
                      <span>Delete</span>
                    )
                  }
                  className="action-button action-button-big"
                />
              </Popconfirm>
            )}

            {Helpers.getPermission(Helpers.permissionEntities.CONSUMPTION_ORDER, Helpers.permissionTypes.CREATE, user) &&
              user?.tenant_info?.sales_config?.sub_modules?.return_slip?.is_active && (
                <Dropdown
                  overlay={renderDropdownMenu}
                  trigger={['click']}
                  placement="bottomLeft"
                >
                  <div
                    style={{ width: '70px', borderRight: 'none', whiteSpace: 'nowrap' }}
                    className="action-button action-button-big"
                    onClick={(e) => e.preventDefault()}
                  >
                    More&nbsp;&nbsp;
                    <FontAwesomeIcon icon={faCaretDown} />
                  </div>
                </Dropdown>
              )}

            {Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.UPDATE, user) &&
              selectedInvoice?.custom_status_info?.type !== 'VOID' && (
                <SelectCustomStatus
                  selectedCustomStatus={selectedInvoice?.custom_status_id}
                  hideTitle
                  tenantId={selectedInvoice?.tenant_id}
                  posibleStatuses={[
                    selectedInvoice?.custom_status_info,
                    ...(selectedInvoice?.possible_status || []),
                  ]}
                  onChange={(value) => {
                    updateInvoiceStatus(
                      {
                        status: value?.type,
                        secondary_status: value?.status_name,
                        invoice_id: selectedInvoice?.invoice_id,
                        custom_status_id: value?.custom_status_id,
                      },
                      () => {
                        getInvoiceById(
                          user?.tenant_info?.org_id,
                          Helpers.getTenantEntityPermission(
                            user?.user_tenants,
                            Helpers.permissionEntities.INVOICE,
                            Helpers.permissionTypes.READ
                          ).join(',') || user?.tenant_info?.tenant_id,
                          match?.params?.consumptionId
                        );
                      }
                    );
                  }}
                  disabled={['VOID', 'SENT_FOR_APPROVAL']?.includes(selectedInvoice?.custom_status_info?.type)}
                  customStyle={{
                    color: selectedInvoice?.custom_status_info?.color_code,
                    backgroundColor: addAlpha?.(selectedInvoice?.custom_status_info?.color_code, 1),
                    height: '35px',
                  }}
                />
              )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewConsumptionHeader;
